// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__35Hwt","errors":"Errors_errors__3XgnZ"};